import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './styles.module.css'
import spanish from '../../../common/language/spanis';
import english from '../../../common/language/english';
import facebookImage from '../../../assets/footer/facebook.png';
import instagramImage from '../../../assets/footer/instagram.png';
import twitterImage from '../../../assets/footer/twitter.png';
import phoneImage from '../../../assets/footer/phone.png';
import emailImage from '../../../assets/footer/mail.png';

let lang = spanish;
class Footer extends Component {

    componentWillReceiveProps(next) {
        // console.log(next);
        if (next.language === 'spanish') {
            lang = spanish;
        }
        else {
            lang = english;
        }
    }

    render() {
        return (
            <div className={styles.footer}>
                <div className={styles.containerRow}>
                    <div className={styles.subContainer} style={{ marginTop: 10 }}>
                        <img src={phoneImage} width="50" />
                        <p>+(521) 442-174-6482</p>
                    </div>
                    <div className={styles.subContainer}>
                        <h1>{lang.footer.follow.title}</h1>
                        <div className={styles.containerRow}>
                            <div className={styles.subContainer}>
                                <a href="https://www.facebook.com/grandPuestaDorada/" target="_blank">
                                    <img src={facebookImage} width="50" />
                                </a>
                            </div>
                            <div className={styles.subContainer}>
                                <a href="">
                                    <img src={twitterImage} width="50" />
                                </a>
                            </div>
                            <div className={styles.subContainer}>
                                <a href="">
                                    <img src={instagramImage} width="50" />
                                </a>
                            </div>
                        </div>
                        <p className={styles.developedTitle}>
                            <a href="https:connectoinnovations.com" target="_blank">
                                {lang.footer.develop.title}
                            </a>
                        </p>
                        <p className={styles.developedSubTitle}>
                            {lang.footer.develop.subTitle}
                        </p>
                    </div>
                    <div className={styles.subContainer} style={{ marginTop: 10 }}>
                        <img src={emailImage} width="50" />
                        <p>puestadorada@gmail.com</p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    language: state.LanguageReducer.language,
});

const mapDispatchToProps = dispatch => ({

});

// make this component available to the app
export default connect(mapStateToProps, mapDispatchToProps)(Footer);

